import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../components/footer/footer.component';
import { HeaderComponent } from '../components/header/header.component';

@Component({
  templateUrl: './account-shell.component.html',
  styleUrls: ['./account-shell.component.scss'],
  standalone: true,
  imports: [RouterOutlet, NgClass, FooterComponent, HeaderComponent],
})
export class AccountShellComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
